import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';
import { PayablesService } from './payables.service';

export interface CheckPrintingSettings {
    defaultCheckFormat: string;
    defaultDisplayBankAccount: boolean;
    defaultDisplayPayor: boolean;
    defaultDisplayCheckNumber: boolean;
    defaultDisplayVendorAddress: boolean;
    /** Whole-page print alignment in mm. +X moves printing right, +Y moves it down. */
    checkPrintOffsetX?: number;
    checkPrintOffsetY?: number;
}

@Injectable({ providedIn: 'root' })
export class CheckPrintingSettingsService {
    private settingsCache$: Observable<CheckPrintingSettings>;

    private readonly DEFAULT_SETTINGS: CheckPrintingSettings = {
        defaultCheckFormat: 'one-per-page',
        defaultDisplayBankAccount: false,
        defaultDisplayPayor: false,
        defaultDisplayCheckNumber: false,
        defaultDisplayVendorAddress: false,
        checkPrintOffsetX: 0,
        checkPrintOffsetY: 0,
    };

    constructor(private _payablesService: PayablesService) {}

    getSettings(): Observable<CheckPrintingSettings> {
        if (!this.settingsCache$) {
            this.settingsCache$ = this._payablesService.getCheckPrintingSettings().pipe(
                    catchError((error) => {
                        console.error('Failed to load check printing settings:', error);
                        return of(this.DEFAULT_SETTINGS);
                    }),
                    shareReplay({ bufferSize: 1, refCount: false }) // Cache and replay for all subscribers
            );
        }
        return this.settingsCache$;
    }

    invalidateCache(): void {
        this.settingsCache$ = null;
    }
}
